import { Chip, TableCell, TableRow } from "@mui/material";
import {
  ContainerCopyCell,
  RowStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableStyled,
  TooltipStyled,
} from "../../shared/styles";
import { ClipLoader } from "react-spinners";
import {
  copyToClipboard,
  formatDate,
  formatLargeText,
} from "../../shared/utils";
import { Copy } from "@phosphor-icons/react";

export const TableTenuiTransactions = ({
  transactions,
  isLoadingTransactions,
  isErrorTransactions,
}) => {
  return (
    <TableStyled>
      <TableHeadStyled>
        <TableRow>
          <TableCell align="center">ID</TableCell>
          <TableCell align="center">Transaction number</TableCell>
          <TableCell align="center">Type</TableCell>
          <TableCell align="center">Sender</TableCell>
          <TableCell align="center">Receiver</TableCell>
          <TableCell align="center">Amount</TableCell>
          <TableCell align="center">Comission in</TableCell>
          <TableCell align="center">Comission out</TableCell>
          <TableCell align="center">Detail</TableCell>
          <TableCell align="center">Date</TableCell>
        </TableRow>
      </TableHeadStyled>
      <TableBodyStyled>
        {isLoadingTransactions ? (
          <TableRow>
            <TableCell colSpan={6} align="center">
              <ClipLoader loading={true} size={24} color="#0197f6" />
            </TableCell>
          </TableRow>
        ) : transactions?.length ? (
          transactions?.map((row) => (
            <RowStyled
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  {formatLargeText(row.transaccionid || "-", 40)}
                  <TooltipStyled title="Copy" placement="top">
                    <Copy
                      color={"#8C8C8C"}
                      size={16}
                      onClick={() => copyToClipboard(row.transaccionid)}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  {formatLargeText(row.numerotransaccion || "-", 40)}
                  <TooltipStyled title="Copy" placement="top">
                    <Copy
                      color={"#8C8C8C"}
                      size={16}
                      onClick={() => copyToClipboard(row.numerotransaccion)}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>
              <TableCellStyled align="center">
                <Chip
                  label={
                    (row.tipomovimientonombre === "Ingreso"
                      ? "Income"
                      : "Outcome") || "-"
                  }
                  sx={{
                    color:
                      row.tipomovimientonombre === "Ingreso"
                        ? "#118FF0"
                        : "#FF0000",
                    fontWeight: "bold",
                    fontSize: "12px",
                    borderRadius: "8px",
                    border: `1px solid ${
                      row.tipomovimientonombre === "Ingreso"
                        ? "#118FF0"
                        : "#FF0000"
                    }`,
                    backgroundColor: "#F5F5F5",
                  }}
                />
              </TableCellStyled>
              <TableCellStyled align="center">
                {row.cuentaorigen_nombre || "-"}
              </TableCellStyled>
              <TableCellStyled align="center">
                {row.cuentadestino_nombre || "-"}
              </TableCellStyled>
              <TableCellStyled align="center">
                $ {row.importe || "-"}
              </TableCellStyled>
              <TableCellStyled align="center">
                $ {row.comision_in || "-"}
              </TableCellStyled>
              <TableCellStyled align="center">
                $ {row.comision_out || "-"}
              </TableCellStyled>
              <TableCellStyled align="center">
                {row.detalle || "-"}
              </TableCellStyled>
              <TableCellStyled align="center">
                {formatDate(row.fecha) || "-"}
              </TableCellStyled>
            </RowStyled>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={6}>
              <h5>
                {isErrorTransactions
                  ? "Error al cargar las transacciones"
                  : "No hay información para mostrar"}
              </h5>
            </TableCell>
          </TableRow>
        )}
      </TableBodyStyled>
    </TableStyled>
  );
};
